import React from "react";
import { KeyRound } from "lucide-react";
import { SETTINGS } from "@/constants/testIds";
import { LabeledInput } from "@/components/settings/LabeledInput";

export function ProfileIdentityFields({ profile, update }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <LabeledInput label="Correo electrónico" type="email" value={profile.email}
        onChange={(e) => update({ email: e.target.value })} placeholder="admin@empresa.com"
        testId={SETTINGS.profileEmailInput} />
      <LabeledInput label="Nombre para mostrar" value={profile.display_name}
        onChange={(e) => update({ display_name: e.target.value })} placeholder="Administrador Principal"
        testId={SETTINGS.profileDisplayNameInput} />
    </div>
  );
}

export function ProfilePasswordFields({ profile, update }) {
  return (
    <div className="pt-4 border-t border-slate-200">
      <div className="flex items-center gap-2 mb-3">
        <KeyRound className="w-4 h-4 text-orange-600" strokeWidth={1.75} />
        <h4 className="text-sm font-semibold text-slate-900">Cambiar contraseña</h4>
        <span className="text-xs text-slate-500">(opcional)</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <LabeledInput className="md:col-span-2" label="Nueva contraseña" type="password"
          value={profile.new_password} onChange={(e) => update({ new_password: e.target.value })}
          placeholder="Mínimo 8 caracteres" autoComplete="new-password"
          testId={SETTINGS.profileNewPasswordInput} />
        <LabeledInput className="md:col-span-2" label="Confirmar nueva contraseña" type="password"
          value={profile.confirm_password} onChange={(e) => update({ confirm_password: e.target.value })}
          placeholder="Repite la nueva contraseña" autoComplete="new-password"
          testId={SETTINGS.profileConfirmPasswordInput} />
      </div>
    </div>
  );
}

export function ProfileCurrentPasswordField({ profile, update }) {
  return (
    <div className="pt-4 border-t border-slate-200">
      <LabeledInput
        label={<>Contraseña actual <span className="text-red-500">*</span></>}
        type="password" value={profile.current_password}
        onChange={(e) => update({ current_password: e.target.value })}
        placeholder="Requerida para confirmar los cambios" autoComplete="current-password"
        testId={SETTINGS.profileCurrentPasswordInput}
        hint="Al cambiar la contraseña, se cerrarán las demás sesiones activas de tu cuenta."
      />
    </div>
  );
}
